import React from "react";
import data from "../../content.json";

const { keyServices5 } = data.edg;

const KeyServices = () => {
  const { id, heading, para, items } = keyServices5;
  
  return (
    <div className="container mx-auto px-4">
      {/* ── 5-Column Cards Grid ── */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 lg:gap-5">
        {items.map((item, index) => (
          <ServiceCard key={item.id} item={item} index={index} />
        ))}
      </div>
    </div>
  );
};

/* ── Service Card ── */

const ServiceCard = ({ item, index }) => {
  return (
    <div className="relative flex flex-col bg-white rounded-xl shadow-sm border border-gray-100 p-6 h-full transition-transform hover:-translate-y-1">
      {/* Content Top */}
      <div className="flex-grow">
        <h3 className="font-bold mb-3">{item.title}</h3>
        <p className="text-gray-600 leading-snug mb-6">
          {item.description}
        </p>
      </div>

      {/* Tag Label (e.g., "Device layer", "EDG core") */}
      <div className="mb-8">
        <span className="bg-[#F0F4FF]  px-4 py-2 rounded-lg font-medium">
          {item.tag || "Process layer"}
        </span>
      </div>

      {/* Step Number Circle (Floating at the bottom) */}
      <div
        className="absolute left-1/2 -bottom-5 -translate-x-1/2 w-10 h-10 rounded-full flex items-center justify-center text-white font-bold shadow-lg"
        style={{ backgroundColor: "#1A2B6D" }}
      >
        {String(index + 1).padStart(2, "0")}
      </div>
    </div>
  );
};

export default KeyServices;
